import { Metadata } from '../../../../../utils/spds/metadata';
import Super from '../base.gjs';
import styles from './negative.module.scss';

const METADATA = Metadata.define({
  description: 'Secondary negative badge indicator.',
  name: 'Negative Secondary Badge',
});

export default class SpdsIndicatorBadgeNegativeSecondary extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  secondary = true;
  variantClass = 'spds-indicator-badge-negative';
  variantStyles = styles;
}

export const BADGE_NEGATIVE_SECONDARY_METADATA = SpdsIndicatorBadgeNegativeSecondary.metadata;
